import React from 'react'

import { themeConfig } from 'themes'

import { COMPONENT_EXTENDER } from 'extender'

const FORM_VERSION = themeConfig.IndividualApplicationForm_Version

const SingleContainerLayout = COMPONENT_EXTENDER('components/layouts/SingleContainerLayout')
const IndividualApplicationFormComponent = COMPONENT_EXTENDER(
    `components/core/ApplicationForms/IndividualApplicationForm/${FORM_VERSION}-IndividualApplicationForm-component`
)

const IndividualApplicationPage = () => (
    <SingleContainerLayout>
        <IndividualApplicationFormComponent />
    </SingleContainerLayout>
)

export default IndividualApplicationPage
